// declaration for the window object
declare const window: any;

export const gtag = window.gtag;
